// Interactive Product Guide — a non-video, slide-deck style presentation
// covering the DENSO product range. Sourced from the DENSO Promoter Training Manual.

export const PRODUCT_SLIDES = [
  {
    id: "spark-plugs",
    title: "Spark Plugs",
    image: "https://images.unsplash.com/photo-1670764169470-bd2f737f9248",
    tagline: "Ignition. Performance. Longevity.",
    points: [
      "Ignites the air/fuel mixture inside a petrol engine.",
      "Technologies: Iridium, Twin Tip Technology (TT), Platinum.",
      "Benefits: longer lifespan, better fuel efficiency, improved performance, reduced emissions.",
    ],
    sellingPoint: "\"DENSO spark plugs improve fuel efficiency and provide longer-lasting performance compared to standard plugs.\"",
  },
  {
    id: "filters",
    title: "Filters — Cool Gear Range",
    image: "https://images.unsplash.com/photo-1642075223291-f9ec545889fa",
    tagline: "Protect the engine. Protect performance.",
    points: [
      "Range includes Air, Oil, Cabin and Fuel filters.",
      "Protects engine components from dirt and contaminants.",
      "Extends engine life and improves fuel efficiency and cabin air quality.",
    ],
    sellingPoint: "Clean filters help vehicles run more efficiently and reduce long-term repair costs.",
  },
  {
    id: "wiper-blades",
    title: "Wiper Blades",
    image: "https://images.unsplash.com/photo-1618934116136-16d28f184b10",
    tagline: "Clear visibility. Every drive.",
    points: [
      "Critical for driver visibility and safety in the rain.",
      "Poor-quality wipers streak, reduce visibility and damage windscreens.",
      "DENSO wipers: smooth performance, durability, reduced noise, high-quality rubber technology.",
    ],
    sellingPoint: "Improved visibility means improved safety — every time.",
  },
  {
    id: "service-kits",
    title: "Service & Filter Kits",
    image: "https://images.pexels.com/photos/8985967/pexels-photo-8985967.jpeg",
    tagline: "Everything in one box.",
    points: [
      "Service Kits: Oil filter, Air filter, Cabin air filter, Fuel filter, Spark plugs.",
      "Filter Kits: a more affordable option excluding spark plugs, same filtration quality.",
      "Gives workshops flexibility between a full premium service or a cost-saving option.",
    ],
    sellingPoint: "Always highlight OE-quality standards and the convenience of everything in one box.",
  },
  {
    id: "twin-horns",
    title: "DENSO Twin Horns",
    image: "https://images.pexels.com/photos/190574/pexels-photo-190574.jpeg",
    tagline: "Powerful. Clear. Reliable.",
    points: [
      "Dual-tone sound: a high-tone horn and a low-tone horn working together.",
      "Built-in relay for simplified, faster installation.",
      "OE quality and reliability in every unit.",
    ],
    sellingPoint: "DENSO Twin Horns come equipped with a built-in relay, making installation faster and easier.",
  },
  {
    id: "rotating-electrics",
    title: "Rotating Electrics — Starters & Alternators",
    image: "https://images.pexels.com/photos/3757226/pexels-photo-3757226.jpeg",
    tagline: "Starting and powering every journey.",
    points: [
      "Starter Motors convert electrical energy into mechanical energy to crank the engine.",
      "Alternators generate electrical power and charge the battery while the engine runs.",
      "DENSO remanufactured units: OE quality, cost effective, fully tested, first-time fit.",
    ],
    sellingPoint: "DENSO is an OEM. Remanufactured units meet OE standards and every unit is fully tested.",
  },
];
